<script lang="ts">
	import { classes } from '$lib/utils';
	import { createEventDispatcher } from 'svelte';

	export let value: string = '';
	export let placeholder: string = '';
	export let additionalClass = '';
	export let focused = false;
	export let errorMessage = 'This field should be filled in';
	export let darkMode = false;
	export let errorClass = '';
	export let hasError = false;
	export let disabled = false;

	let input: HTMLTextAreaElement;

	const dispatch = createEventDispatcher();

	$: {
		if (input && focused) {
			input.focus();
		}
	}
</script>

<!-- Placeholder: gray lighter -->
<div>
	<div class="flex flex-col gap-2">
		<textarea
			bind:this={input}
			{placeholder}
			class={classes(
				'py-3 px-5 w-full !min-h-[132px] text-sm rounded-lg disabled:opacity-75 bg-gray-50 border-1 border-gray-200 focus:outline-none focus:ring-0 focus:border-purple',
				hasError ? errorClass : '',
				darkMode
					? 'text-white border-white placeholder:text-white'
					: 'text-black border-black placeholder:text-grey-500',
				additionalClass
			)}
			{disabled}
			style="resize: none;"
			bind:value
			on:input={() => dispatch('input', value)}
			{...$$restProps}
		/>
		{#if hasError}
			<span class="text-error">{errorMessage}</span>
		{/if}
	</div>
</div>
